import request from "@/utils/request";

// 分页查询
export function queryApprovalTable(data) {
  return request({
    url: "/approval/page",
    method: "post",
    data,
  });
}

// 待办、已办、发起 数量查询
export function queryApprovalCount(data) {
  return request({
    url: "/approval/selectPageByCount",
    method: "post",
    data,
  });
}

// 提交审核
export function submitApproval(data) {
  return request({
    url: "/approval/submitTask",
    method: "post",
    data,
  });
}

// 审批详情
export function queryApprovalDetailById(id) {
  return request({
    url: `/approval/getApprovalDetail/${id}`,
    method: "post",
  });
}

// 根据审批id查询详情（出、入库）
export function queryStorageDetailById(approvalId) {
  return request({
    url: `/approval/getBoundByApproval/${approvalId}`,
    method: "get",
  });
}
